<template>
  <div id="page" :class="{fixed: showScreenDialog || isActivityModal.length}">
    <div class="app-content" :class="{show: show}">
      <div class="tabs-panel" v-if="couponActivity.length || userUnusedCoupons.length">
        <router-link class="router-link-exact-active" :to="{path: '/home', query: {appid: appEnv.appId, platformid: appEnv.platformId || 0, appkey: appEnv.appKey}}">话费充值</router-link>
        <router-link :to="{path: '/coupons', query: {appid: appEnv.appId, platformid: appEnv.platformId || 0, appkey: appEnv.appKey, uid: userInfo.id, invite_code: userInfo.invite_code}}" >领券中心</router-link>
        <router-link :to="{path: '/orders', query: {appid: appEnv.appId, platformid: appEnv.platformId || 0, appkey: appEnv.appKey, uid: userInfo.id, invite_code: userInfo.invite_code, isCoupon: 1}}">充值历史</router-link>
      </div>
      <div class="banner" v-else>
        <span class="icon"><i class="iconfont icon-huafei"></i></span>
        <span class="text">话费充值</span>
        <span class="bg"><i class="iconfont icon-huafeiquan"></i></span>
      </div>
      <div class="layer layer-1">
        <div class="title">充值账号</div>
        <div class="input"><input v-model="phone" type="tel" placeholder="请输入手机号" :disabled="isLimitRecharge" :class="{disabled: isLimitRecharge}" v-debounce:200="onSearchHistory"></div>
        <div class="tips">温馨提示：请确保账号无误，充值成功后不支持退换。</div>
        <div class="input-select-dropdown" v-if="historyRecords.length">
          <ul>
            <li @click="() => onSelectPhone(item)" v-for="item of historyRecords" :key="item.id"><span class="text">{{item._mobile}}</span><span class="type">{{item._mobile_type}}</span><span class="date">上次充值：{{item._created_at}}</span></li>
          </ul>
        </div>
      </div>
      <div class="layer layer-2" v-if="serveEnable">
        <div class="title">充值类型</div>
        <div class="tags">
          <span :class="{cur: rechargeType === 1}" v-if="showSlowRecharge" @click="() => changeRechargeType(1)">慢充</span>
          <span :class="{cur: rechargeType === 2}" v-if="showQuickRecharge" @click="() => changeRechargeType(2)">快充</span>
        </div>
      </div>
      <div class="layer coupon-list">
        <div class="item" v-for="(item, key) of userUnusedCoupons" :key="item.id" v-if="item.discount.specs.recharge_type === rechargeType">
          <div class="price">
            <div class="wrap">
              <span class="currency">¥</span>
              <span class="num">{{item.discount.discount}}</span>
            </div>
            <div class="text" v-if="item.discount.specs.recharge_type === 1">慢充{{item.discount.specs.amount}}元可用</div>
            <div class="text" v-if="item.discount.specs.recharge_type === 2">快充{{item.discount.specs.amount}}元可用</div>
          </div>
          <div class="flex">
            <div class="name" v-if="item.activity.rule_user_type === 1">
              <span>新人话费券</span><span v-if="item.batch > 1"> x {{ item.batch }}</span>
            </div>
            <template v-else>
              <div class="name" v-if="item.activity.rule_time_type === 'month'">月度话费券</div>
              <div class="name" v-if="item.activity.rule_time_type === 'week'">周度话费券</div>
              <div class="name" v-if="item.activity.rule_time_type === 'day'">天天话费券</div>
            </template>
            <div class="desc">领取后{{item.activity.expiry_day}}天有效<br/>领取时间：{{moment(item.created_at).format('YYYY-MM-DD')}}</div>
            <div class="btn" @click="() => onUseCoupon(item)">去使用</div>
            <div class="icon"><img src="@/assets/images/lqu.png" alt=""></div>
          </div>
        </div>
      </div>
      <div class="layer layer-3">
        <div class="title">充值面额</div>
        <div class="desc" v-if="!serveEnable">{{stopServeMsg}}</div>
        <template v-else>
          <div class="tags" v-if="show && rechargeType === 1">
            <div class="item" v-for="(item, key) in slowSpecs" :key="key" @click="() => specs = item" :class="{cur: specs && specs.id === item.id}">
              <span class="price1">{{item.amount}}元</span>
              <div class="price2" v-if="item.disabled"><span class="text" style="color: #d06926">{{mobileTypeName}}暂无库存</span></div>
              <template v-else>
                <div class="price2" v-if="!item._have_coupon"><span class="text">售价</span><span class="num">{{item.money}}</span><span class="text">元</span></div>
                <div class="price2" v-else><span class="text">券后</span><span class="num">{{item._true_money}}</span><span class="text">元</span></div>
              </template>
            </div>
          </div>
          <div class="tags" v-if="show && rechargeType === 2">
            <div class="item" v-for="(item, key) in quickSpecs" :key="key" @click="() => specs = item" :class="{cur: specs && specs.id === item.id}">
              <span class="price1">{{item.amount}}元</span>
              <div class="price2" v-if="item.disabled"><span class="text" style="color: #d06926">{{mobileTypeName}}暂无库存</span></div>
              <template v-else>
                <div class="price2" v-if="!item._have_coupon"><span class="text">售价</span><span class="num">{{item.money}}</span><span class="text">元</span></div>
                <div class="price2" v-else><span class="text">券后</span><span class="num">{{item._true_money}}</span><span class="text">元</span></div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="layer layer-4">
        <div class="tips-title"><i class="icon iconfont icon-tishi"></i><span>温馨提示</span></div>
        <ul class="list" v-if="rechargeType === 1">
          <li v-for="(item, key) in pageReminder" :key="key" v-html="item"></li>
        </ul>
        <ul class="list" v-if="rechargeType === 2">
          <li v-for="(item, key) in pageQuickReminder" :key="key" v-html="item"></li>
        </ul>
      </div>
      <div class="cashier">
        <div class="issue" @click="onIssue">
          <span class="icon"><i class="iconfont icon-runtongyiyaoyihuifu_wenti-22"></i></span>
          <span class="text">咨询客服</span>
        </div>
        <div class="order" @click="onOrders">
          <span class="icon"><i class="iconfont icon-dingdan"></i></span>
          <span class="text">订单查询</span>
        </div>
        <div class="btn" v-if="show">
          <button @click="onVerify">立即充值<template v-if="specs">（¥{{specs._have_coupon ? specs._true_money : specs.money}}）</template></button>
        </div>
      </div>
      <div v-if="showDialogPay" class="confirm-pay">
        <div class="weui-mask" @click="onCancel2"></div>
        <div class="weui-half-screen-dialog" :class="{'weui-half-screen-dialog_show': showScreenDialog}">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">支付方式</strong>
            </div>
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="onCancel2">关闭<i class="weui-icon-close-thin"></i></button>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <div class="pay-list">
              <div class="item" @click="() => onConfirm('wxpay')" :class="{disabled: !isWxPay}">
                <span class="icon"><img src="@/assets/images/wxpay.png" alt=""></span>
                <span class="text">微信支付</span>
              </div>
              <div class="item" @click="() => onConfirm('alipay')" :class="{disabled: !isAliPay}">
                <span class="icon"><img src="@/assets/images/alipay.png" alt=""></span>
                <span class="text">支付宝</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showDialogConfirm" class="cashier-dialog">
        <div class="weui-mask"></div>
        <div class="weui-half-screen-dialog" :class="{'weui-half-screen-dialog_show': showScreenDialog}">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">¥{{specs._have_coupon ? specs._true_money : specs.money}}</strong>
            </div>
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="onCancel"><i class="weui-icon-close-thin"></i></button>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <ul class="bill-info">
              <li><span class="label">订单信息</span><span class="text">话费{{rechargeType === 2 ? '快' : '慢'}}充{{specs.amount}}元</span></li>
              <li v-if="specs._have_coupon"><span class="label">优惠券</span><span class="text">{{specs._discount}}元优惠券</span></li>
              <li><span class="label">充值号码</span><span class="text b">{{phone}}</span></li>
              <li><span class="label">支付方式</span><span class="text">{{payType === 'alipay' ? '支付宝' : '微信'}}</span></li>
            </ul>
            <div class="desc">
              <h5>充值须知</h5>
              <ul v-if="rechargeType === 1">
                <li v-for="(item, key) in pageReminder" :key="key" v-html="item"></li>
              </ul>
              <ul v-if="rechargeType === 2">
                <li v-for="(item, key) in pageQuickReminder" :key="key" v-html="item"></li>
              </ul>
            </div>
            <div class="confirm-check weui-cells weui-cells_checkbox">
              <label class="weui-cell weui-cell_active weui-check__label">
                <div class="weui-cell__hd">
                  <input type="checkbox" v-model="confirmCheck" class="weui-check">
                  <i class="weui-icon-checked"></i>
                </div>
                <div class="weui-cell__bd">我已阅读并了解【充值须知】，并已确认充值手机号码</div>
              </label>
            </div>
          </div>
          <div class="weui-half-screen-dialog__ft">
            <a href="javascript:" class="weui-btn weui-btn_primary" @click="onSubmit">立即支付</a>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="showDialogLimit" class="confirm-dialog">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提示</strong></div>
            <div class="weui-dialog__bd">{{limitRechargeMsg}}</div>
            <div class="weui-dialog__ft">
              <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="showDialogLimit = false">知道了</a>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="isActivityModal.length">
        <div class="weui-mask"></div>
        <div class="weui-dialog dialog-activity">
          <div class="dialog-title">{{isActivityModal[0].name}}</div>
          <div class="coupon-list">
            <template v-for="(activity) in isActivityModal">
              <div class="item" v-for="(item, key) in activity.discounts" :key="item.id">
                <div class="price">
                  <div class="wrap">
                    <span class="currency">¥</span>
                    <span class="num">{{item.discount}}</span>
                  </div>
                </div>
                <div class="flex">
                  <div class="name" v-if="activity.rule_user_type === 1">
                    <span>新人话费券</span><span v-if="item.batch > 1"> x {{ item.batch }}</span>
                  </div>
                  <template v-else>
                    <div class="name" v-if="activity.rule_time_type === 'month'"><span>月度话费券</span><span v-if="item.batch > 1"> x {{ item.batch }}</span></div>
                    <div class="name" v-if="activity.rule_time_type === 'week'"><span>周度话费券</span><span v-if="item.batch > 1"> x {{ item.batch }}</span></div>
                    <div class="name" v-if="activity.rule_time_type === 'day'"><span>天天话费券</span><span v-if="item.batch > 1"> x {{ item.batch }}</span></div>
                  </template>
                  <!-- TODO 弃用
                  <div class="desc b" v-if="activity.rule_time_type === 'week'">每周{{week[activity.rule_week]}}{{activity.rule_hour}}点{{activity.rule_minute}}分开抢</div>
                  <div class="desc b" v-if="activity.rule_time_type === 'month'">每月{{activity.rule_day}}号{{activity.rule_hour}}点{{activity.rule_minute}}分开抢</div>
                  <div class="desc b" v-if="activity.rule_time_type === 'day'">每天{{activity.rule_hour}}点{{activity.rule_minute}}分开抢</div>-->
                  <div class="desc" v-if="item.specs.recharge_type === 1">慢充{{ item.specs.amount }}元可用，领取后{{activity.expiry_day}}天有效</div>
                  <div class="desc" v-if="item.specs.recharge_type === 2">快充{{ item.specs.amount }}元可用，领取后{{activity.expiry_day}}天有效</div>
                </div>
              </div>
            </template>
          </div>
          <div class="weui-dialog__ft">
            <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="receiveCoupon">立即领取</a>
          </div>
          <div class="close" @click="() => isActivityModal = []">
            <img src="@/assets/images/close.png" alt="">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  #page {
    min-height: 100vh;
  }
  #page.fixed {
    height: 100vh;
    overflow: hidden;
  }
  .app-content {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .app-content.show {
    opacity: 1;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 0.2s;
  }
  .landscape-enter {
    opacity: 0;
  }
  .landscape-enter-active {
    transition: opacity 0.2s;
  }
  .translate-enter {
    transform: translateY(100%);
  }
  .translate-active {
    transition: transform .3s;
  }
  .weui-half-screen-dialog {
    max-height: 95%;
    transform: translateY(100%);
    transition: transform .3s;
    &.weui-half-screen-dialog_show {
      transform: translateY(0);
    }
  }
  .cashier-dialog {
    .weui-half-screen-dialog__title {
      font-size: 26px;
      font-weight: 500;
      text-align: center;
    }
    .weui-half-screen-dialog__bd {
      padding-bottom: 16px;
    }
    .weui-half-screen-dialog__ft {
      padding-bottom: 32px;
      .weui-btn_primary {
        width: 100%;
        background-color: #d8c078;
        color: #fff;
        font-weight: normal;
        border-radius: 20px;
      }
    }
    .bill-info {
      li {
        display: flex;
        justify-content: space-between;
        padding: 4px 0;
        .label {
          color: #999;
        }
        .text {
          color: #333;
          &.b {
            color: #d06926;
          }
        }
      }
    }
    .desc {
      max-height: 240px;
      overflow-y: auto;
      color: #333;
      h5 {
        font-size: 15px;
        padding-bottom: 5px;
        padding-top: 16px;
      }
      ul {
        list-style: none;
        li {
          font-size: 13px;
          text-align: left;
          color: #444;
          padding-bottom: 2px;
          b {
            color: red;
          }
        }
      }
    }
    .confirm-check {
      display: flex;
      flex-direction: row;
      align-content: center;
      padding-top: 12px;
      margin-top: 12px;
      &:after{
        display: none;
      }
      .weui-cell {
        padding: 0;
      }
      .weui-check__label {
        background-color: #fff;
      }
      .weui-cell__hd {
        padding-right: 8px;
      }
      .weui-cell__bd {
        font-size: 13px;
        text-align: left;
        color: #444;
      }
    }
  }
  .confirm-dialog .weui-dialog__hd {
    padding: 24px 24px 12px;
  }
  .confirm-dialog .weui-dialog__title{
    font-size: 16px;
    font-weight: 600;
  }
  .confirm-dialog .weui-dialog__bd {
    padding-bottom: 0;
    margin-bottom: 22px;
  }
  .confirm-dialog .weui-dialog__bd .phone {
    padding-bottom: 10px;
  }
  .confirm-dialog .weui-dialog__bd .desc ul {
    list-style: none;
    max-height: 176px;
    padding-top: 6px;
    overflow-y: auto;
  }
  .confirm-dialog .weui-dialog__bd .desc li {
    font-size: 13px;
    text-align: left;
    color: #555;
    padding-bottom: 6px;
  }
  .confirm-dialog .weui-dialog__bd .desc li b {
    color: red;
  }
  .confirm-dialog .weui-dialog__bd .phone span {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    padding: 8px 18px;
    border-radius: 22px;
    background-color: #f7f4ef;
    color: #d06926;
  }
  .confirm-dialog .weui-dialog__bd .specs {
    color: #666;
  }
  .confirm-dialog .weui-dialog__btn {
    font-weight: 600;
  }
  .confirm-dialog .weui-dialog__btn.weui-dialog__btn_primary {
    color: #b29960;
  }
  .confirm-pay .weui-half-screen-dialog__hd__main+.weui-half-screen-dialog__hd__side {
    right: 16px;
  }
  .confirm-pay .weui-half-screen-dialog {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    padding: 0;
  }
  .confirm-pay .weui-half-screen-dialog__hd {
    height: 6.5em;
    border-bottom: 1px #efefef solid;
  }
  .confirm-pay .weui-half-screen-dialog__bd {
    padding-bottom: 30px;
  }
  .confirm-pay .weui-half-screen-dialog__title {
    text-align: center;
    font-size: 17px;

  }
  .confirm-pay .pay-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 16px;
    justify-content: space-around;
  }
  .confirm-pay .pay-list .item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .confirm-pay .pay-list .item.disabled img {
    filter: grayscale(100%);
  }
  .confirm-pay .pay-list .item .icon {
    height: 58px;
    display: flex;
    align-items: center;
  }
  .confirm-pay .pay-list .item .icon img{
    width: 44px;
    color: #555;
    font-size: 16px;
  }
  .app-content {
    height: 100%;
    padding-bottom: 2px;
    overflow-x: hidden;
    overflow-y: auto;
    .tabs-panel {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 2.15rem;
      padding: 0 14px;
      font-size: 15px;
      color: #333;
      font-weight: 500;
      background-color: #fff;
      border-bottom: 1px #efefef solid;
    }

    .tabs-panel a {
      flex: 1;
      position: relative;
      text-align: center;
      padding: 3px 0;
      font-size: 17px;
      font-weight: 600;
      color: #333;
    }

    .tabs-panel a.router-link-exact-active {
      color: #b29960;
    }

    .tabs-panel a.router-link-exact-active:after {
      position: absolute;
      left: 50%;
      bottom: -0.25rem;
      width: 1.5em;
      height: 4px;
      background-color: #b29960;
      content: '';
      margin-left: -0.75em;
      border-radius: 4px;
      overflow: hidden;
    }
  }

  .app-content .banner{
    position: relative;
    height: 2.85rem;
    background-color: #fff0cf;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 0.85rem;
  }

  .app-content .banner .icon {
    height: 1.5rem;
    width: 1.5rem;
    background-image: linear-gradient(#edd08c, #d8c078);
    border-radius: 0.6rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .app-content .banner .icon .iconfont {
    font-size: 23px;
    padding-top: 1px;
  }

  .app-content .banner .text {
    font-size: 18px;
    font-weight: bold;
    padding-left: 10px;
  }

  .app-content .banner .bg {
    position: relative;
    flex: 1;
    height: 2.85rem;
    overflow: hidden;
  }

  .app-content .banner .bg .iconfont {
    position: absolute;
    right: -40px;
    top: -54px;
    font-size: 116px;
    color: #ecdeb0;
    transform: rotate(332deg);
  }

  .app-content .layer {
    margin: 14px;
    padding: 12px 14px;
    background-color: #fff;
  }

  .app-content .layer .title {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 12px;
  }

  .app-content .layer-1 {
    position: relative;
    .input-select-dropdown {
      position: absolute;
      top: 5.25rem;
      left: 0;
      right: 0;
      max-height: 200px;
      overflow-y: auto;
      z-index: 101;
      box-sizing: border-box;
      padding: 4px 0;
      background-color: #fff;
      border-radius: 2px;
      outline: none;
      box-shadow: 0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05);
      ul {
        list-style: none;
        padding: 14px;
        li {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          .text {
            color: #333;
            font-size: 18px;
            font-weight: 500;
          }
          .type {
            padding-left: 10px;
            color: #999;
            font-size: 17px;
          }
          .date {
            flex: 1;
            text-align: right;
            color: #999;
            font-size: 13px;
          }
        }
      }
    }
  }

  .app-content .layer-1 .input {
    border-bottom: 1px #efefef solid;
  }

  .app-content .layer-1 .input input {
    height: 3.5rem;
    line-height: 3.5rem;
    border: 0;
    background-color: #fff;
    font-size: 30px;
    width: 100%;
    outline:none;
    &.disabled {
      color: #000;
    }
  }

  .app-content .layer-1 .tips {
    padding-top: 0.7rem;
    font-size: 13px;
    color: #d06926;
  }

  .app-content .layer-2 .tags {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 12px;
  }

  .app-content .layer-2 .tags span {
    width: 4.1rem;
    height: 1.75rem;
    line-height: 1.8rem;
    text-align: center;
    background-color: #f8f8f8;
    border-radius: 6px;
    margin-right: 12px;
    font-size: 16px;
    color: #5a3a14;
    font-weight: bold;
    border: 2px #f8f8f8 solid;
  }

  .app-content .layer-2 .tags span.cur {
    background-color: #fbf8f1;
    border: 2px #a79d68 solid;
  }

  .app-content .layer-3 {
    min-height: 6rem;
    padding: 12px;
    .desc {
      padding: 8px;
      color: #333;
      font-size: 13px;
      background-color: #fff1b8;
      border-radius: 4px;
    }
  }

  .app-content .layer-3 .tags {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
  }

  .app-content .layer-3 .tags .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30%;
    height: 25vw;
    background-color: #f8f8f8;
    border-radius: 6px;
    margin-right: 0.425rem;
    margin-bottom: 0.425rem;
    border: 2px #f8f8f8 solid;
  }

  .app-content .layer-3 .tags .item.cur {
    background-color: #fbf8f1;
    border: 2px #a79d68 solid;
  }

  .app-content .layer-3 .tags .item:last-child {
    margin-right: 0;
  }

  .app-content .layer-3 .tags .item:nth-child(3n+0) {
    margin-right: 0;
  }

  .app-content .layer-3 .tags .item .price1 {
    font-size: 18px;
    color: #5a3a14;
    font-weight: bold;
  }

  .app-content .layer-3 .tags .item .price2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .app-content .layer-3 .tags .item .price2 .text {
    font-size: 13px;
    color: #999;
  }
  .app-content .layer-3 .tags .item .price2 span {
  }

  .app-content .layer-3 .tags .item .price2 .unit {
    font-size: 13px;
    color: #5a3a14;
    font-weight: bold;
    padding-bottom: 1px;
    padding-right: 2px;
  }

  .app-content .layer-3 .tags .item .price2 .num {
    font-size: 15px;
    color: #5a3a14;
    font-weight: bold;
    padding: 0 2px 2px;
  }

  .app-content .layer-3 .tags .item .price3 {
    color: #d4ccbf;
    font-size: 12px;
    text-decoration: line-through;
  }

  .app-content .layer-4 {
    margin-bottom: 3.5rem;
  }

  .app-content .layer-4 .tips-title {
    margin-left: 0.4rem;
    margin-top: 0.5rem;
    background-image: linear-gradient(to right, #e4d3a7 , #dfc47d);
    display: inline-block;
    font-size: 14px;
    color: #fff;
    font-weight: 200;
    padding: 2px 6px;
    border-radius: 8px 0 8px 0;
  }

  .app-content .layer-4 .list {
    list-style: none;
    margin-left: 0.4rem;
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
  }

  .app-content .layer-4 .list li {
    font-size: 14px;
    line-height: 1.6;
    padding-bottom: 6px;
  }

  .app-content .layer-4 .list li b {
    color: red;
  }

  .app-content .cashier {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3rem;
    display: flex;
    background-color: #fff;
    flex-direction: row;
    align-items: center;
  }

  .app-content .cashier .issue,
  .app-content .cashier .order {
    width: 23%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
  }

  .app-content .cashier .icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 1.25rem;
  }

  .app-content .cashier .issue .icon .iconfont {
    font-size: 28px;
  }

  .app-content .cashier .order .icon .iconfont {
    font-size: 24px;
  }
  .app-content .cashier .issue .text,
  .app-content .cashier .order .text {
    padding-top: 4px;
    font-weight: 400;
  }

  .app-content .cashier .order {
    margin-left: -2%;
  }

  .app-content .cashier .btn {
    flex: 1;
    height: 100%;
    margin-left: 10px;
    background-image: linear-gradient(to right, #4e4e4e , #262626);
  }

  .app-content .cashier .btn button {
    border: 0;
    background: none;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #e7dcc6;
    font-size: 18px;
    font-weight: bold;
    outline: none;
  }

  .dialog-activity {
    top: 47%;
    background-color: #e76436;
    overflow: visible;
    .dialog-title {
      height: 2.825rem;
      line-height: 2.825rem;
      font-size: 24px;
      color: #fffac5;
      font-weight: 500;
    }

    .coupon-list {
      padding: 0 16px;
      margin-bottom: 16px;
      max-height: 340px;
      overflow-y: auto;
      .item {
        &:first-child {
          margin-top: 0;
        }
        margin: 14px 0;
        height: 82px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #fff;
        border-radius: 6px;
        text-align: left;
        .icon {
          height: 100%;
          background-image: linear-gradient(to right, #fbeea1 , #f8db7e);
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 70%;
          }
        }
        .price {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: baseline;
          justify-content: center;
          color: #df4439;
          font-weight: 600;
          width: 30%;
          height: 100%;
          background-image: linear-gradient(to right, #fbeea1 , #f8db7e);
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          .wrap {
            padding-top: 16px;
          }
          .currency {
            font-size: 16px;
            margin-right: 4px;
          }
          .num {
            font-size: 32px;
            font-family: 'DIN1451';
          }
          &:after, &:before {
            position: absolute;
            top: -5px;
            right: -5px;
            width: 10px;
            height: 10px;
            background-color: #e76436;
            border-radius: 5px;
            content: '';
          }
          &:before {
            top: auto;
            bottom: -5px;
          }
        }
        .flex {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 0 0.585rem;
          .name {
            color: #333;
            font-size: 17px;
            font-weight: 500;
          }
          .desc {
            color: #90929b;
            font-size: 12px;
            &.b {
              font-size: 13px;
              color: #e76436;
            }
          }
        }
      }
    }
    .weui-dialog__ft {
      &:after {
        display: none;
      }
      height: 1.8rem;
      line-height: 1.85rem;
      justify-content: center;
      min-height: auto;
      padding-bottom: 1rem;
      .weui-dialog__btn {
        flex: none;
        width: 50%;
        color: #723607;
        background-color: #f6c24d;
        border-radius: 1.8rem;
        font-size: 20px;
      }
    }
    .close {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -42px;
      text-align: center;
      img {
        width: 32px;
      }
    }
  }
  .layer.coupon-list {
    background: none;
    padding: 0;
    margin: 0 16px;
    .item {
      &:first-child {
        margin-top: 0;
      }
      margin: 14px 0;
      height: 82px;
      display: flex;
      flex-direction: row;
      align-items: center;
      background-image: linear-gradient(to right, #ec5250 , #f86d4e);
      border-radius: 4px;
      text-align: left;
      .price {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        font-weight: 600;
        width: 33%;
        height: 100%;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        .wrap {
          padding-top: 13px;
          line-height: 1.1;
        }
        .currency {
          font-size: 16px;
          margin-right: 4px;
        }
        .num {
          font-size: 32px;
          font-family: 'DIN1451';
        }
        .text {
          color: rgba(255, 255, 255, 0.8);
          font-size: 13px;
          font-weight: normal;
        }
        &:after, &:before {
          position: absolute;
          top: -5px;
          right: -5px;
          width: 10px;
          height: 10px;
          background-color: #fff;
          border-radius: 5px;
          content: '';
        }
        &:before {
          top: auto;
          bottom: -5px;
        }
      }
      .flex {
        position: relative;
        flex: 1;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0 0.585rem;
        height: 100%;
        &:after {
          position: absolute;
          left: 0;
          top: 10px;
          bottom: 10px;
          content: '';
          border-left: 1px #b82418 dashed;
        }
        .name {
          color: #fff;
          font-size: 17px;
          font-weight: 500;
        }
        .desc {
          color: rgba(255, 255, 255, 0.8);
          font-size: 12px;
        }
        .icon {
          position: absolute;
          top: 0;
          right: 34%;
          height: 100%;
          img {
            display: none;
            margin-top: 7%;
            height: 90%;
          }
        }
        .btn {
          position: absolute;
          width: 2.7rem;
          height: 1.2rem;
          line-height: 1.2rem;
          text-align: center;
          top: 50%;
          right: 0.585rem;
          margin-top: -0.5rem;
          border-radius: 6px;
          font-size: 14px;
          color: #ec5250;
          background-color: #f9de4f;
          font-weight: 500;
        }
      }
    }
  }
  @media screen and (max-width: 320px) {
    .app-content .layer-3 .tags .item {
      width: 45.5%;
      &:nth-child(2n+0) {
        margin-right: 0;
      }
      &:nth-child(3n+0) {
        margin-right: 0.425rem;
      }
    }
    .app-content .cashier .issue,
    .app-content .cashier .order {
      font-size: 12px;
    }
    .app-content .cashier .btn button {
      font-size: 16px;
    }
    .app-content .layer-4 .list li {
      font-size: 13px;
    }
  }
</style>

<script>
import request from "@/pages/wechat/mobile/utils/request";
import gfRequest from "@/pages/wechat/mobile/utils/gfRequest";
import moment from 'moment';
import global from "@/pages/wechat/mobile/store/modules/global";
export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      showToast: false,
      showDialogConfirm: false,
      showDialogPay: false,
      showDialogLimit: false,
      showScreenDialog: false,
      pageReminder: [],
      pageQuickReminder: [],
      isExpiryAtOut: false,
      toastMsg: '',
      confirmCheck: true,
      disabled: false,
      phone: '',
      payType: '',
      rechargeType: 1,
      slowSpecs: [],
      quickSpecs: [],
      showSlowRecharge: true,
      showQuickRecharge: true,
      historyRecords: [],
      couponActivity: [],
      userCoupons: [],
      userUnusedCoupons: [],
      isActivityModal: [],
      specs: null,
      checkUserInfo: false,
      isWxPay: true,
      isAliPay: false,
      isLimitRecharge: false,
      isLimitQuickRecharge: false,
      customChannel: 0,
      limitRechargeMsg: '',
      memberId: null,
      week: ['日','一','二','三','四','五','六'],
      tenantConfig: {},
      redirectUri: null,
      signUri: null,
      officialAppId: null,
      officialCode: null,
      channelConfig: [],
      accountConfig: [],
      serveEnable: true,
      stopServeMsg: null,
    };
  },
  created() {
    if (!this.appEnv.prod) {
      const appEnv = {
        prod: this.appEnv.prod,
        appId: 'CC202104110012172897',
        platformId: 117,
      }
      this.$store.dispatch('global/saveAppEnv', appEnv)
      new VConsole();
    }
    this.redirectUri = location.origin + location.pathname
    this.signUri = location.href.replace(/([#][^#]+)$/g, '')
  },
  mounted() {
    this.officialCode = $QueryString.Get('code') || this.$route.query.code || '';
    const appEnv = this.appEnv;
    if (!this.officialCode) {
      const appId = this.$route.query.appid ||'';
      const platformId = this.$route.query.platformid || '';
      if (appId) appEnv.appId = appId;
      if (platformId) appEnv.platformId = parseInt(platformId, 10) || 0;
    } else {
      const state = $QueryString.Parse(decodeURIComponent($QueryString.Get('state') || this.$route.query.state));
      const {appid, platformid, appkey} = state;
      if (appid) appEnv.appId = appid;
      if (appkey) appEnv.appKey = appkey
      if (platformid) appEnv.platformId = parseInt(platformid, 10) || 0;
    }
    if (!appEnv.appId || !appEnv.platformId) {
      this.showLoading = false;
      this.show = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    this.$store.dispatch('global/saveAppEnv', appEnv);
    new Promise(async (resolve, reject) => {
      if (this.userInfo.id) {
        return resolve();
      }
      const error1 = await this.getOfficialSign().then((resp) => {
        const appEnv = this.appEnv;
        const {appId, sdk} = resp.data;
        this.officialAppId = appId;
        const wxConfig = {
          debug    : false,
          appId    : sdk.app_id,
          timestamp: sdk.timestamp,
          nonceStr : sdk.nonce_str,
          signature: sdk.signature,
          jsApiList: [
            'chooseWXPay',
            'openLocation',
            'scanQRCode',
            'onMenuShareTimeline',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'onMenuShareAppMessage'
          ],
        };
        wx.config(wxConfig);
        wx.error((error) => {
          request({
            url: `/open/api/analysis/log`,
            method: 'POST',
            data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: error.errMsg},
          }).then().catch(err => {})
        });
        appEnv.appKey = this.officialAppId;
        this.$store.dispatch('global/saveAppEnv', appEnv);
        return null;
      }).catch((error) => {
        this.showLoading = false;
        this.show = true;
        this.toast('服务存在异常，错误码：10002', false)
        return error
      });
      if (error1) return;
      const status = encodeURIComponent($QueryString.ToString(this.appEnv).slice(1));
      if (!this.officialCode) {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.officialAppId}&redirect_uri=${this.redirectUri}&response_type=code&scope=snsapi_base&state=${status}#wechat_redirect`
        return reject();
      } else {
        this.officialScope().then((resp) => {
          const {user, snsapi} = resp.data;
          if (snsapi === 1) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.officialAppId}&redirect_uri=${this.redirectUri}&response_type=code&scope=snsapi_userinfo&state=${status}#wechat_redirect`
            return reject();
          }
          this.$store.dispatch('global/saveUserInfo', user)
          return resolve();
        }).catch((error) => {
          this.showLoading = false;
          this.show = true;
          this.toast('登录失败，请联系客服', false)
          return reject();
        });
      }
    }).then(async () => {
      this.showLoading = true;
      this.getAppConf().catch(err => {})
      await this.getTenantCfg().catch((err) => {});
      await this.getSpecs().then().catch(err => {});
      if (this.userInfo.mobile) {
        this.phone = this.userInfo.mobile.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
      }
      if (!this.showSlowRecharge && this.showQuickRecharge) {
        this.changeRechargeType(2)
      }
      this.show = true;
      setTimeout(() => {
        this.showLoading = false;
      }, 150);
    })

  },
  computed: {
    userInfo() {
      return this.$store.state.global.userInfo
    },
    appEnv() {
      return this.$store.state.global.appEnv
    },
    mobileType() {
      const phone = this.phone.replace(/\s*/g, '');
      if (phone.length === 11) {
        const isChinaMobile = /^134[0-8]\d{7}$|^(?:13[5-9]|147|148|15[0-27-9]|178|172|1703|1705|1706|18[23478]|19[58])\d{7,8}$/; //移动
        const isChinaTelcom = /^(?:133|153|1700|1701|1702|177|173|18[019]|191|193|199)\d{7,8}$/; //电信
        const isChinaUnion = /^(?:13[0-2]|145|15[56]|166|175|176|1704|1707|1708|1709|171|18[56])\d{7,8}$/; //联通
        if (isChinaMobile.test(phone)) {
          return 'cmcc'
        } else if (isChinaUnion.test(phone)) {
          return 'cucc'
        } else if (isChinaTelcom.test(phone)) {
          return 'ctcc'
        }
      } else {
        return  ''
      }
    },
    mobileTypeName() {
      if (this.mobileType === 'cmcc') {
        return '移动'
      } else if (this.mobileType === 'cucc') {
        return '联通'
      } else if (this.mobileType === 'ctcc') {
        return '电信'
      } else {
        return  ''
      }
    },
    rechargeTypeName() {
      if (this.rechargeType === 2) {
        return '快充'
      } else {
        return '慢充'
      }
    }
  },
  watch: {
    phone(newValue, oldValue) { // 监听
      this.phone = newValue.replace(/\s*/g, '').length > 11 ? oldValue : (newValue.length > oldValue.length ? newValue.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3').trim() : this.phone.trim())
      const phone = this.phone.replace(/\s*/g, '');
      if (phone.length === 11) {
        const channel = this.channelConfig.filter(t => t.type === this.mobileType)
        for (const spec of this.slowSpecs) {
          spec.disabled = false
          for (const ch of channel) {
            if (spec.amount === ch.amount) {
              spec.disabled = !ch.slow_enable
              break
            }
          }
        }
        for (const spec of this.quickSpecs) {
          spec.disabled = false
          for (const ch of channel) {
            if (spec.amount === ch.amount) {
              spec.disabled = !ch.quick_enable
              break
            }
          }
        }
      } else {
        for (const spec of this.slowSpecs) {
          spec.disabled = false
        }
        for (const spec of this.quickSpecs) {
          spec.disabled = false
        }
      }
    },
  },
  methods: {
    moment,
    isWechat() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    },
    isIOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    toast(v, write = true) {
      this.toastMsg = v;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000)
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    phoneFormat(v) {
      return v.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3').trim()
    },
    getOfficialSign() {
      return gfRequest({
        url: `/api/official/sign`,
        method: 'POST',
        data: {appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, uri: this.signUri}
      });
    },
    officialScope() {
      return gfRequest({
        url: `/api/official/scope`,
        method: 'POST',
        data: {appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, code: this.officialCode}
      });
    },
    getAppConf() {
      return new Promise(async (resolve, reject) => {
        let globalChannelConfig = []
        let channelConfig = []
        let accountConfig = []
        await request({
          url: `/open/api/sys/conf`,
          method: 'GET',
        }).then((resp) => {
          globalChannelConfig = resp.channel || []
        }).catch(err => {
          reject(err)
        })

        await request({
          url: `/open/api/account/conf`,
          method: 'GET',
          params: {platformId: this.appEnv.platformId}
        }).then((resp) => {
          channelConfig = resp.channel || []
          accountConfig = resp.list || []
          if (channelConfig.length) {
            if (!this.customChannel) {
              for (const t of channelConfig) {
                let exist = false;
                const find = globalChannelConfig.find(v => v.amount === t.amount && v.type === t.type)
                if (find && !find.slow_enable) {
                  t.slow_enable = !!find.slow_enable
                  exist = true
                }
                if (find && !find.quick_enable) {
                  t.quick_enable = !!find.quick_enable
                  exist = true
                }
                if (!exist) {
                  t.slow_enable = !!t.slow_enable;
                  t.quick_enable = !!t.quick_enable;
                }
              }
            }
            this.channelConfig = channelConfig
          } else {
            this.channelConfig = globalChannelConfig
          }
          this.showSlowRecharge = this.channelConfig.filter(t => t.slow_enable).length > 0
          this.showQuickRecharge = this.channelConfig.filter(t => t.quick_enable).length > 0
          let mobileServiceStartDate, mobileServiceEndDate, mobileStopServiceText = null
          let mobileEnable = true
          for (const t of accountConfig) {
            const {field, value} = t
            if (field === 'MobileEnable') {
              mobileEnable = !!+value
            }
            if (field === 'MobileServiceStartDate') {
              mobileServiceStartDate = +value
            }
            if (field === 'MobileServiceEndDate') {
              mobileServiceEndDate = +value
            }
            if (field === 'MobileStopServiceText') {
              mobileStopServiceText = value
            }
          }
          this.serveEnable = !this.showSlowRecharge && !this.showQuickRecharge ? false : mobileEnable;
          this.stopServeMsg = mobileStopServiceText
          if (mobileEnable && mobileServiceStartDate && mobileServiceEndDate) {
            const nowDate = this.moment().date()
            if (nowDate < mobileServiceStartDate || nowDate > mobileServiceEndDate) {
              this.serveEnable = false
            }
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    getCouponActivity() {
      const newRequest = request({
        url: `/open/api/coupon/activity`,
        method: 'GET',
        params: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, invite_code: this.userInfo.invite_code, valid: 1}
      });
      newRequest.then((resp) => {
        const now = new Date();
        const userCoupons = [];
        for (const t of this.userCoupons) {
          if (t.activity_type === 'coupon') {
            if (t.activity.rule_time_type === 'day') {
              const diffTime = this.moment(t.created_at).add(1, 'days').hour(t.activity.rule_hour).minute(t.activity.rule_minute);
              if (diffTime.isAfter(now)) {
                userCoupons.push(t);
              }
            }
            if (t.activity.rule_time_type === 'month') {
              const diffTime = this.moment(t.created_at).add(1, 'months').hour(t.activity.rule_hour).minute(t.activity.rule_minute);
              if (diffTime.isAfter(now)) {
                userCoupons.push(t);
              }
            }
            if (t.activity.rule_time_type === 'week') {
              const diffTime = this.moment(t.created_at).add(1, 'weeks').hour(t.activity.rule_hour).minute(t.activity.rule_minute);
              if (diffTime.isAfter(now)) {
                userCoupons.push(t);
              }
            }
            if (!t.activity.is_reuse) {
              userCoupons.push(t);
            }
          }
        }
        const ids = [...new Set(userCoupons.map(t => {
          if (t.activity_type === 'coupon') {
            return t.activity1_id;
          } else if (t.activity_type === 'register'){
            return t.activity2_id;
          }
        }))];
        const activity = resp.list || [];
        const activityValid = activity.map(t => {
          t._valid = !ids.includes(t.id);
          return t;
        });
        const activityFilter = activityValid.filter(t => t._valid && t.is_modal).filter(t => {
          if (t.rule_user_type === 1) {
            if (!this.userInfo.jointime_text) {
              return false;
            }
            const joinTime = this.moment(this.userInfo.jointime_text);
            const expiryDate = this.moment(new Date()).subtract(t.rule_register, 'days');
            if (joinTime.isBefore(expiryDate)) {
              return false;
            }
          }
          if (t.verify_phone && !this.userInfo.mobile) {
            return false;
          }
          if (t.verify_wechat && !this.userInfo.wechat_unionid) {
            return false;
          }
          if (t.verify_taobao && this.userInfo.beian_url) {
            return false;
          }
          if (t.verify_order_num && this.userInfo.order_num <= t.verify_order_num ) {
            return false;
          }
          return true;
        });
        this.couponActivity = activityValid || [];
        this.isActivityModal = activityFilter || [];
      });
      return newRequest;
    },
    getMemberCoupon() {
      const newRequest = request({
        url: `/open/api/member/coupon`,
        method: 'GET',
        params: {uid: this.userInfo.id, memberId: this.memberId, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, invite_code: this.userInfo.invite_code}
      });
      newRequest.then((resp) => {
        resp = (resp || []).map(t => {
          t.activity = t[t.activity_type + '_activity'];
          t.discount = t[t.activity_type + '_discount'];
          if (t.activity_type === 'coupon') {
            t.discount_id = t.discount1_id
          }
          if (t.activity_type === 'register') {
            t.discount_id = t.discount2_id
          }
          return t;
        });
        this.userCoupons = resp || [];
        this.userUnusedCoupons = resp.filter(t => !t.status && this.moment(t.expiry_at).isAfter(new Date()))
      });
      return newRequest;
    },
    receiveCoupon() {
      if (this.disabled) {
        return;
      }
      this.showLoading = true;
      this.disabled = true
      const len = this.isActivityModal.length
      let batch = 0;
      const fn1 = async (id) => {
        await request({
          url: `/open/api/receive/coupon`,
          method: 'POST',
          data: {activity_id: id, uid: this.userInfo.id, memberId: this.memberId, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, invite_code: this.userInfo.invite_code, jointime: this.userInfo.jointime_text},
        }).then(() => {
          batch++;
          if (batch === len) {
            this.showLoading = false;
            this.disabled = false;
            this.$router.push({
              path: '/coupons',
              query: {appid: this.appEnv.appId, platformid: this.appEnv.platformId || 0, appkey: this.appEnv.appKey, uid: this.userInfo.id, invite_code: this.userInfo.invite_code}
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.showLoading = false;
          this.isActivityModal = [];
          if (error.response && error.response.data) {
            this.toast(error.response.data.msg);
          } else {
            this.toast("领取失败");
          }
        });
      };
      for (const item of this.isActivityModal) {
        fn1(item.id)
      }
    },
    changeRechargeType(v) {
      this.rechargeType = v;
      if (v === 2) {
        this.isLimitQuickRecharge = !!this.tenantConfig.limit_quick_recharge
      } else {
        this.isLimitRecharge = !!this.tenantConfig.limit_recharge
      }
      const phone = this.phone.replace(/\s*/g, '');
      if (phone !== this.userInfo.mobile && ((this.rechargeType === 1 && this.isLimitRecharge) || (this.rechargeType === 2 && this.isLimitQuickRecharge))) {
        this.phone = this.userInfo.mobile.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
        this.limitRechargeMsg = (this.rechargeType === 2 ? '快充' : '慢充') + '仅支持充值用户绑定的手机号'
        this.showDialogLimit = true;
      }
    },
    getTenantCfg() {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, isWechat: 1 }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, custom_channel, page_reminder, page_reminder2, limit_recharge} = resp;
        this.tenantConfig = resp;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.isLimitRecharge = !!limit_recharge;
        this.customChannel = custom_channel;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        this.pageQuickReminder = page_reminder2 ? page_reminder2.split(/[\n\r]/g) : `1.一般充值1-30分钟内到账，如遇月末月初充值高峰期或系统更新期会稍有延迟【24小时内给出结果】。
2.目前支持移动、联通、电信三网号段，<b>携号转网号码暂不能充值</b>，否则损失自负无法退款。
3.<b>此服务为虚拟充值类服务，无特殊情况不支持退款</b>
4.<b>空号、错号充值后不支持退款或修改</b>，请您务必核对确认号码无误后再进行充值。非空号欠费可充，<b>欠费1个月导致空号的不能充值</b>，损失自负无法退款。
5.移动会不定期维护网络，维护期间可能会造成延后到账，请耐心等待。维护网络期间如造成无法充值或手机账号停机欠费充值失败，款项将原路退回。
6.本充值业务不提供发票。如需发票请在运营商手机客户端处开取电子发票，也可以凭身份证到运营商实体营业厅打印发票。
7.如遇系统维护充值失败，将24小时内原路退款到付款账户。`.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getSpecs() {
      const newRequest = request({
        url: `/open/api/recharge/specs`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId}
      });
      newRequest.then((resp) => {
        const data = resp.list.map(t => {
          const coupon = this.userUnusedCoupons.find(v => v.discount.specs_id === t.id);
          t._have_coupon = !!coupon;
          t._true_money = coupon ? (t.money - coupon.discount.discount).toFixed(2) : null;
          t._discount = coupon ? coupon.discount.discount : null;
          t._discountId = coupon ? coupon.discount.id : null;
          t._couponSn = coupon ? coupon.coupon_sn : null;
          if (coupon && t._true_money < 0) {
            t._true_money = 0
          }
          return t;
        });
        this.slowSpecs = data.filter(t => t.recharge_type === 1).map(t => {
          t.disabled = false
          return t
        });
        this.quickSpecs = data.filter(t => t.recharge_type === 2).map(t => {
          t.disabled = false
          return t
        });
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onIssue() {
      // openLinkByAlias('customerService');
    },
    onOrders() {
      if (!this.userInfo.id) {
        this.toast('未能获取到用户信息请联系客服: ');
      } else {
        this.$router.push({
          path: '/orders',
          query: {appid: this.appEnv.appId, platformid: this.appEnv.platformId || 0, appkey: this.appEnv.appKey, uid: this.userInfo.id, isCoupon: +!!(this.couponActivity.length || this.userUnusedCoupons.length)},
        });
      }
    },
    onSearchHistory() {
      const phone = this.phone.replace(/\s*/g, '');
      if (phone.length > 3 && phone.length < 11) {
        request({
          url: `/open/api/member/orders`,
          method: 'GET',
          params: {search: phone, uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, invite_code: this.userInfo.invite_code}
        }).then((resp) => {
          this.historyRecords = resp ? resp.map(t => {
            switch (t.mobile_type) {
              case 'cmcc':
                t._mobile_type = '移动';
                break;
              case 'cucc':
                t._mobile_type = '联通';
                break;
              case 'ctcc':
                t._mobile_type = '电信';
                break;
            }
            t._mobile = t.mobile.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3').trim();
            t._created_at = t.created_at.split(' ')[0];
            return t;
          }) : [];
        });
      } else {
        this.historyRecords = [];
      }
    },
    onSelectPhone(record) {
      this.phone = record._mobile;
      this.historyRecords = [];
    },
    onCancel() {
      this.showScreenDialog = false;
      setTimeout(() => {
        this.showDialogConfirm = false;
      }, 300)
    },
    onCancel2() {
      this.showScreenDialog = false;
      setTimeout(() => {
        this.showDialogPay = false;
      }, 300)
    },
    onUseCoupon(event) {
      if (!this.phone) {
        this.toast('请输入手机号码', false);
        return;
      }
      const specsId = event.discount.specs_id;
      let findOne = null;
      if (this.rechargeType === 1) {
        findOne = this.slowSpecs.find(t => t.id === specsId);
      } else if (this.rechargeType === 2) {
        findOne = this.quickSpecs.find(t => t.id === specsId);
      }
      if(findOne) {
        this.specs = findOne;
        this.onVerify();
      } else {
        this.toast("优惠券选取异常，请联系客服")
      }
    },
    onVerify() {
      if (this.disabled) {
        return;
      }
      if (this.isExpiryAtOut) {
        this.toast('服务存在异常，错误码：10001');
        return;
      }
      if (this.appEnv.prod && !this.isWechat()) {
        this.toast('请移至微信平台访问');
        return;
      }
      if (!this.specs) {
        this.toast('请选择充值面额', false);
        return;
      }
      if (!/^1\d{10}$/.test(this.phone.replace(/\s*/g, ''))) {
        this.toast('手机号码格式不正确', false);
        return;
      }
      const channel = this.channelConfig.find(t => t.type === this.mobileType && t.amount === this.specs.amount)
      if (channel && ((this.rechargeType === 1 && !channel.slow_enable) || (this.rechargeType === 2 && !channel.quick_enable))) {
        this.toast(`${this.mobileTypeName}${this.rechargeTypeName}${this.specs.amount}元面额库存不足，请尝试选择其它面额。`);
        return;
      }
      this.onConfirm();
    },
    onConfirm(v) {
      if (!this.isWxPay) {
        this.toast('商户暂不支持微信支付', false);
        return;
      }
      this.payType = v;
      this.showDialogPay = false;
      this.showScreenDialog = false;
      this.showDialogConfirm = true;
      setTimeout(() => {
        this.showScreenDialog = true;
      }, 0)
    },
    onSubmit() {
      if (!this.confirmCheck) {
        this.toast('请阅读并同意充值须知', false);
        return;
      }
      this.disabled = true;
      this.showLoading = true;

      const body = {type: this.payType, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, specs_id: this.specs.id, phone: this.phone.replace(/\s*/g, ''), uid: this.userInfo.id, nickname: this.userInfo.nickname, avatar: this.userInfo.avatar};
      if (this.specs._have_coupon) {
        body.discount_id = this.specs._discountId;
        body.coupon_sn = this.specs._couponSn;
      }
      request({
        url: `/open/api/recharge/jspay`,
        method: 'POST',
        data: body,
      }).then((resp) => {
        this.disabled = false;
        setTimeout(() => {
          this.showLoading = false;
          this.showScreenDialog = false;
          this.showDialogConfirm = false;
        }, 1000);
        wx.chooseWXPay({
          timestamp: resp.timestamp,
          nonceStr: resp.nonceStr,
          package: resp.package,
          signType: resp.signType,
          paySign: resp.paySign,
          success: (v) => {
            this.onOrders();
          },
          cancel: () => {
            this.onOrders();
          }
        })
      }).catch((error) => {
        this.disabled = false;
        this.showLoading = false;
        this.showScreenDialog = false;
        setTimeout(() => {
          this.showDialogConfirm = false;
          if (error.response && error.response.data) {
            this.toast(error.response.data.msg);
          }
        }, 250)
      });
    }
  }
}
</script>
